<template>
    <div class="">
        <div class="modal fade" id="loginMoblizer" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body login-mobilizer text-left p-4">
                        <div class="login-mobilizer-inner p-5">
                            <img class="logo mb-3" src="'/images/logo2.png" alt="" />
                            <div class="moblizer-account-login">
                                <span class="title mb-2"> Your <span class="highlight-color">OTP</span> will be send to your mobile number/registered email address. </span>
                                <div class="form-group mb-2">
                                    <input v-model="form.companyWalletID" readonly type="text" class="form-control" name="companyWalletID" :class="{ 'is-invalid': form.errors.has('companyWalletID') }" />
                                    <has-error :form="form" field="companyWalletID"></has-error>
                                </div>
                                <span class="title mb-2"> Click generate button to proceed? </span>
                                <div class="row normal-ib-space">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                    <div class="col"> <button :disabled="form.busy" class="btn btn-primary proceed active" @click="generatePin"> Generate </button> </div>
                                </div>
                            </div>
                            <div class="moblizer-account-detail hide">
                                <label class="label block-label"> Please enter the OTP </label>
                                <div class="form-group mb-2">
                                    <input v-model="processForm.pin_code" @keypress="isNumber($event)" type="text" class="form-control" />
                                </div>
                                <div class="row normal-ib-space mt-3">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close" @click="cancelMobilizer"> Cancel </button> </div>
                                    <div class="col"> 

                                    <!-- <button :disabled="!processForm.pin_code" class="btn btn-primary active" @click="proceedLogin"> Proceed </button>  -->
                                    <button :disabled="proceedButtonClicked || !processForm.pin_code" class="btn btn-primary active" @click="proceedLogin"> Proceed </button>

                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    export default {
        props: ['billIds','topup_id','paymentType','payroll_id','payrollTotalAmount', 'payableTxnAmount'],

        data() {
            return {
                proceedButtonClicked: false,
                form: new Form({
                    companyWalletID     : '',
                    payrollTotalAmount  : '',
                    payableTxnAmount    : '',
                    payroll_id          : '',
                    paymentType         : '',
                    billIds             : '',
                    topup_id            : '',
                }),
                processForm : new Form({
                    customerName            : '',
                    IBAN                    : '',
                    balance                 : '',
                    Cookie                  : '',
                    sessionId               : '',
                    paymentInstrumentBankAccountNumber  : '',
                    paymentInstrumentIdSVA  : '',
                    customerId              : '',
                    billIds                 : '',
                    payroll_id              : '',
                    topup_id                : '',
                    paymentType             : '',
                    paymentReprocess        : false
                }),
            };
        },
        mounted() {
            setTimeout(() => {
                this.form.payrollTotalAmount = this.payrollTotalAmount;
                this.form.payableTxnAmount = this.payableTxnAmount;
                this.processForm.payroll_id = this.form.payroll_id = this.payroll_id;
                this.processForm.topup_id = this.form.topup_id = this.topup_id;
                this.processForm.billIds = this.form.billIds = this.billIds;
                this.form.paymentType = this.processForm.paymentType = this.paymentType;
            },2000);
            this.getCompanyAccountNo();

            // EventBus.$on('paymentReprocess', data => {
            //    this.processForm.paymentReprocess = data;
            // });
        },
        methods:{
            getCompanyAccountNo(){
                this.$Progress.start();
                axios.get('/api/getCompanyAccountNo')
                    .then(res => {
                        if(res.status == 200){
                            this.form.companyWalletID = res.data.company.phone;
                            this.processForm.companyWalletID = res.data.company.walletID;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    });
            },
            generatePin: function(){
                this.processForm.topup_id = this.form.topup_id = this.topup_id;
                this.$Progress.start();
                this.form.post('/api/generatePinCodeVA')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.status == 200){
                                this.showToastBox('success','Please proceed your batch.');
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showToastBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showToastBox('error','Some problem in your form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showToastBox('error','Some problem in your form data');
                    });
            },
            proceedLogin: function(){
                this.$Progress.start();
                if (this.proceedButtonClicked) {
                    return;
                }
                this.proceedButtonClicked = true;
                this.processForm.post('/api/verifyPinCodeVA')
                    .then(res => {
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            if(this.$global.user_company_payment_engine == 'FINCA' || this.$global.user_company_payment_engine == 'EMONEY'){
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.sessionId = res.data.data.sessionId;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                this.processForm.customerId = res.data.data.customerId;
                            }
                            this.processPayments();
                        }else{
                            this.proceedButtonClicked = false;
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                            $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                            $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            processPayments: function(){
                this.$Progress.start();
                var url = '';
                if(this.paymentType == 'employee_payment'){
                    url = '/api/proceedBatchQueue';
                }else if(this.paymentType == 'bill_payment'){
                    url = '/api/billSendForPayment';
                }else if(this.paymentType == 'topup_payment'){
                    url = '/api/proceedTopupQueue';
                }else if(this.paymentType == 'vendor_payment'){
                    url = '/api/VendorSendForPayment';
                }else if(this.paymentType == 'retailer_payment'){
                    url = '/api/VendorSendForPayment';
                }else if(this.paymentType == 'pms_membership_payment'){

                    this.showToastBox('success', 'Suceess');
                    $('#loginMoblizer').modal('hide');

                    this.$emit('optVerified', {
                        bank: 'virtual',
                        data: null
                    });

                    this.$Progress.finish();

                    return true;
                }
                if(url == ''){
                    this.showAlertBox('error','Some problem in your form data, please contact Finja Business.');
                    return;
                }
                this.processForm.post(url)
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.code == 200) {
                                this.showToastBox('success',res.data.message);
                            } else {
                                this.showToastBox('error',res.data.message);
                            }

                            $('#loginMoblizer').modal('hide');
                            if(this.paymentType == 'employee_payment'){
                                this.$router.push('/employeePayments');
                            }else if(this.paymentType == 'bill_payment'){
                                this.$router.push('/billPayments');
                            }else if(this.paymentType == 'retailer_payment'){
                                this.$router.push('/retailerPayment');
                            }else if(this.paymentType == 'topup_payment'){
                                this.$router.push('/topupsPayments');
                            }else{
                                this.$router.push('/vendorPayment');
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
        },
        destroyed: function() {
            // EventBus.$off('paymentReprocess');
        }


    }
</script>
